<template>
  <v-content>
    <v-card elevation="0">
      <v-list>
        <v-list-tile class="tileTitle" avatar>
          <v-list-tile-avatar
            size=32
            tile>
            <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <span class="text-white text-truncate-popover">Import Google Classroom Course</span>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              dark
              icon
              @click="closeWindow">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-container>
        <v-layout row class="loaderRow">
          <v-flex>
            <v-progress-linear
              indeterminate
              v-if="loadingData || loadingInitialData"
              class="py-0 my-0"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout
          row
          v-if="!loadingInitialData">
          <v-flex>
            <v-card
              v-if="userHasGoogleCourses" id="classPickerCard" height="500">
              <v-card-title class="mb-0 pb-0">
                <h3 class="title">Google Classes for {{googleClassroomClasses.user.emailAddress}}</h3>
              </v-card-title>
              <v-card-text class="my-0 py-0">
                <a @click="loadClasses(true)">Switch account</a>
              </v-card-text>
              <v-list two-line>
                <v-list-tile
                  v-for="course in googleClassroomClasses.courses"
                  :key="course.id"
                  avatar
                >
                  <v-list-tile-avatar
                    tile
                    size=32>
                    <img src="https://bunny.playposit.com/images/add_to_googleclassroom.png" alt="Google Classroom Logo">
                  </v-list-tile-avatar>
      
                  <v-list-tile-content>
                    <v-list-tile-title>{{ course.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ course.section }}</v-list-tile-sub-title>
                  </v-list-tile-content>
      
                  <v-list-tile-action>
                    <v-btn
                      v-if="!course.isSynced"
                      outline
                      color="#2196F3"
                      small
                      @click="handleClassImport(course.id)"
                      :disabled="loadingData">
                      Import
                      <v-icon
                        small
                        class="ml-1">input</v-icon>
                    </v-btn>
                    <span
                      v-else
                      class="success--text">
                      Imported
                      <v-icon color="success">done</v-icon>
                    </span>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>
            <div
              v-else>
              <h3
                class="headline">Looks like you don't have any courses in your Google Classroom.</h3>
              <p
                class="body-2">You are currently signed in as {{googleClassroomClasses.user.emailAddress}}.
                <br>
                Try creating a course in Google Classroom or you can <a @click="loadClasses(true)">switch Google Accounts.</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-content>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import storejs from 'store';
import _ from 'lodash';

export default {
  name: 'GoogleClassPicker',
  data() {
    return {
      googleClassroomClasses: [],
      loadingInitialData: true,
      loadingData: true,
    };
  },
  computed: {
    assignmentTitleErrors() {
      const errors = [];
      if (!this.$v.assignmentTitle.$dirty) return errors;
      if (!this.$v.assignmentTitle.required) {
        errors.push('Title is required.');
      }
      return errors;
    },
    userHasGoogleCourses() {
      return _.get(this.googleClassroomClasses, 'courses', []).length;
    },
  },
  methods: {
    ...mapMutations([
      'triggerSnackbar',
    ]),
    ...mapActions('instructors', [
      'getGoogleClassroomData',
      'importGoogleClassroomCourse',
    ]),
    closeWindow() {
      window.close();
    },
    async handleClassImport(courseId) {
      try {
        this.loadingData = true;
        const { data : classes } =  await this.importGoogleClassroomCourse({
          courseId,
          token: storejs.get('pp_instructor_token'),
        });
        dataLayer.manualLog(`googleClassroom: class imported`, 'googleClassroom');
        this.googleClassroomClasses = classes;
        // send postMessage to trigger Dash refresh
        window.opener.postMessage({
          type: 'playposit__class_import',
          action: 'refresh',
        }, '*');
      } catch(e) {
        this.triggerSnackbar({
          text: 'Error importing class.',
          color: 'error',
          timeout: 5000,
        });
      } finally {
        this.loadingData = false;
      }
    },
    async loadClasses(switchAccount = '') {
      try {
        const classroomData = await this.getGoogleClassroomData(
        {
          token: storejs.get('pp_instructor_token'),
          state: _.get(this.$route, 'query.state', ''),
          code: switchAccount ? '' : _.get(this.$route, 'query.code', ''),
          redirectURL: window.location.href.split('?')[0],
          switchAccount,
        });
        if (typeof classroomData.data === 'string' && classroomData.data.includes('accounts.google.com/o/oauth2')) {
          window.resizeTo(900, 900);
          window.location.replace(classroomData.data);
        } else {
          window.resizeTo(900, 700);
          this.googleClassroomClasses = classroomData.data;
          this.loadingInitialData = false;
          this.loadingData = false; 
        }
      } catch(e) {
        this.triggerSnackbar({
          text: 'Error getting class data.',
          color: 'error',
          timeout: 5000,
        });
      }
    }
  },
  beforeMount() {
    this.loadClasses();
  },
  mounted() {
    let state = decodeURIComponent(this.$route.query.state);
    this.queryParams = JSON.parse(state);
  }
};
</script>

<style>
  .tileTitle {
    background-color: #2196F3;
  }
  .loaderRow {
    min-height: 25px;
  }
  #classPickerCard {
    overflow-y: scroll;
  }
</style>
